import request from '@/utils/request'
import host from '@/api/base/host'
import { AsyncRequest } from '@/utils/request'

const share = host.path('loca:ljs', { module: 'share', dev: 'v1' })

export default {
  //获取专辑详情
  getAlbumInfo(data) {
    return request({
      url: share('goods/getAlbumGoodsDetail'),
      method: 'post',
      data
    })
  },
  //获取专辑详情
  getAlbumCourse(data) {
    return request({
      url: share('goods/getFilterAlbumCourseGoodsList'),
      method: 'post',
      data
    })
  },
  //获取订单状态
  getOrderStatus(data) {
    return request({
      url: share('order/getPayStatusByPrePayId'),
      method: 'post',
      data
    })
  },
  //预创建订单
  orderPreCreate(data) {
    return request({
      url: share('order/preCreate'),
      method: 'post',
      data
    })
  },
  //创建订单
  orderCreate(data) {
    return request({
      url: share('order/create'),
      method: 'post',
      data
    })
  },
  //课程详情页是否弹添加班主任
  getAdviserInfo(data) {
    return request({
      url: share('goods/getCourseActivityInfo'),
      method: 'post',
      data
    })
  },
  //获取解锁订单状态
  getUnlockOrderStatus(data) {
    data.prePayId = data.prePayId || data.paymentPrepayId || data.prepayid || data.prepay_id
    return request({
      url: share('order/getPayStatusByUnlockPrePayId'),
      method: 'post',
      data
    })
  }
}
